/**
 * Call Firebase cloud function to cast votes
 * @param token   idToken from Firebase auth
 * @param body    {voterKey, candidateKeyList} when logging in with an ID and password
 * @returns {Promise<unknown>} See Firebase function doc header for details
 *                             about return object
 * @private
 */
const castVote = async (token, body) => {
  const rootUrl = document.location.hostname === ('localhost') ?
    'http://localhost:5001/onlineballot/us-central1' :
    'https://us-central1-onlineballot.cloudfunctions.net';
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  body = {...body, token}
  return new Promise((resolve, reject) => {
    fetch(rootUrl + '/castVote', {
      method: 'POST',
      body: body ? JSON.stringify(body) : '{}',
      headers,
      // mode: 'cors'
    })
      .then(res => {
        return res.json()
      })
      .then(jsonData => {
        resolve(jsonData);
      })
      .catch(err => {
        reject(err);
      })
  });
}

export default castVote;
